import React from 'react';
import { IDEStatsResponse, WebStatsResponse } from '../../types/dashboard';
import { convertIDECostToCredits, calculateWebCredits } from '../../config/costs';

interface Props {
  ideStats?: IDEStatsResponse | null;
  webStats?: WebStatsResponse | null;
  isLoading: boolean;
}

const TotalCredits: React.FC<Props> = ({ ideStats, webStats, isLoading }) => {
  if (isLoading) {
    return (
      <div className="stats-card hover:border-primary-500/20 group animate-pulse">
        <div className="p-6">
          <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-24 mb-4"></div>
          <div className="h-8 bg-gray-200 dark:bg-gray-700 rounded w-32"></div>
        </div>
      </div>
    );
  }

  if (!ideStats || !webStats) return null;

  const ideCredits = convertIDECostToCredits(ideStats.ide_stats.total_cost);
  const webCredits = calculateWebCredits(
    webStats.web_stats.total_input_tokens,
    webStats.web_stats.total_output_tokens
  );
  const totalCredits = ideCredits + webCredits;

  return (
    <div className="stats-card hover:border-primary-500/20 group">
      <div className="p-6">
        <h2 className="text-xl font-medium text-gray-900 dark:text-white">Total Credits</h2>
        <p className="text-4xl font-bold text-gray-900 dark:text-white mt-4">
          {totalCredits.toFixed(2)}
        </p>
      </div>
    </div>
  );
};

export default TotalCredits;
